import { useState } from "react";
import {
    RegistrationService,
    SendRegistrationOtpInput,
} from "../../../api/psc";
import { createRandomId } from "../../../utils/random";
import { usePostRegistrationData } from "../api-hooks/usePostRegistration";
import { useRegistrationContext } from "../context/registrationContext";
import { useRegistrationRequestInputCreator } from "../hooks/useRegistrationRequestInputCreator";
import SubmitRegistrationView from "./SubmitRegistrationView";

export default function SubmitRegisterContainer() {
    const [activeStep, setActiveStep] = useState(0);
    const [captchaAction, setCaptchaAction] = useState(createRandomId(5));
    const { state, dispatch } = useRegistrationContext();

    const registrationRequestInputCreator =
        useRegistrationRequestInputCreator();

    // Step Handlers
    const handleNext = () => {
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
    };
    const handleReset = () => {
        setActiveStep(0);
    };

    // API calls
    // Utilized in Step One
    const { inProgress, postRegistrationData } = usePostRegistrationData();

    const handlePostTrueDryRun = async () => {
        const requestInput = registrationRequestInputCreator(true);

        try {
            await postRegistrationData(requestInput);
            const isOk = await handleSendOtpCall();
            if (isOk) handleNext();
        } catch (error) {
            dispatch({ type: "setError", payload: error });
        }
    };

    // Utilized in step two
    const handlePostFalseDryRun = async () => {
        const requestInput = registrationRequestInputCreator(false);

        try {
            const registrationCode = await postRegistrationData(requestInput);
            dispatch({
                type: "setRegistrationCode",
                payload: registrationCode,
            });
            handleNext();
        } catch (error) {
            dispatch({ type: "setError", payload: error });
        }
    };

    // Utilized in resend button and step two initialization
    const handleSendOtpCall = async (): Promise<boolean> => {
        const registrationSendObj: SendRegistrationOtpInput = {
            captcha: state.captcha,
            mobileNumber: state.contactNumber,
        };

        try {
            await RegistrationService.sendOtp("1", registrationSendObj);
            setCaptchaAction(createRandomId(5));
            return true;
        } catch (error) {
            dispatch({ type: "setError", payload: error });
            return false;
        }
    };

    const handleRedirect = () => {
        const code = state.registrationCode;
        window.location.href = `${process.env.REACT_APP_AUTHORITY}/impersonate?c=${code}`;
    };

    return (
        <SubmitRegistrationView
            activeStep={activeStep}
            handleReset={handleReset}
            // API Functions
            // Utilized in Step One
            handlePostTrueDryRun={handlePostTrueDryRun}
            // Utilized in Step Two
            handlePostFalseDryRun={handlePostFalseDryRun}
            handleSendOtpCall={handleSendOtpCall}
            // Utilized in Step Three
            handleRedirect={handleRedirect}
            // In Progress Flag for both Step One and Two
            inProgress={inProgress}
            captchaAction={captchaAction}
        />
    );
}
